"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderEachRowDataBasedOnDataType = exports.renderObjectOptions = void 0;
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var renderObjectOptions = function (selectedObjectModel) {
  var option = [];
  selectedObjectModel.map(function (eachModel) {
    option.push({
      key: eachModel.id,
      label: eachModel.name
    });
    return "";
  });
  return option;
};
exports.renderObjectOptions = renderObjectOptions;
var renderEachRowDataBasedOnDataType = function (value) {
  if (react_1.default.isValidElement(value)) {
    return value;
  } else if (value instanceof Date) {
    return (0, moment_1.default)(value).format("DD/MM/YYYY");
  } else if (typeof value === "boolean") {
    return value.toString();
  } else if (typeof value === "object") {
    if (Object.keys(value).includes("name")) {
      return value.name;
    } else if (Object.keys(value).includes("seconds")) {
      return (0, moment_1.default)(value.seconds).format("DD/MM/YYYY");
    } else {
      if (Array.isArray(value)) {
        return value.toString();
      } else {
        var returnValue_1 = "";
        Object.values(value).map(function (eachObjValue) {
          if (typeof eachObjValue === "string") {
            returnValue_1 = eachObjValue;
          }
          return null;
        });
        return returnValue_1;
      }
    }
  } else {
    return value;
  }
};
exports.renderEachRowDataBasedOnDataType = renderEachRowDataBasedOnDataType;